import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialDetailDto } from '@models/material-detail-dto.interface';

@Component({
  selector: 'app-material-detail',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './material-detail.component.html',
  styleUrl: './material-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialDetailComponent {
  @Input() material: MaterialDetailDto | null = null;
  @Output() editRequested = new EventEmitter<number>();

  protected onEditClick(): void {
    if (this.material) {
      this.editRequested.emit(this.material.id);
    }
  }
}
